<template>
<div class="form">
  <v-card style="margin-top: 250px">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <h1 align="center" style="text-decoration: underline overline;">JRE - SEKSYEN 1 : PENDIDIKAN</h1>

        <v-text-field
          outlined 
          dense
          rounded
          v-model="HID"
          label="HID"
          width="20px"
          disabled
        ></v-text-field>


      <!-- DATATABLE  -->
      <v-card  color="rgba(217, 217, 217, 0.5)" class="mb-5">
            <v-card-title>
                Senarai
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>

              <v-spacer></v-spacer>
                <v-btn
                color="error"
                small
                @click="dialogPengesahan=true;"
                >
                  Padam JRE
                </v-btn>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="dataJRE1"
              :search="search"
              class="ml-3 mr-3"
              @click:row="handleClick"
              :footer-props="{'items-per-page-options':[3,15, 30, 50, 100, -1]}"
            >
            <!-- <template v-slot:[`item.SR`]="{ item }">
                    {{ paparSR(item.SR) }}
                  </template>  -->
            </v-data-table>
      </v-card>   
    </v-card>


<v-card>
  <span style="color:red;font-weight:bold;font-size: small;"><v-col>Medan yang bertanda * wajib diisi</v-col></span>
  <v-card-title>
   SEKSYEN 1 : PENDIDIKAN
   (Pilih satu jawapan sahaja)
  </v-card-title>
  <v-card-text>
    <v-form       ref="form"       v-model="valid"       lazy-validation     > 
      <!-- <v-form ref="form" v-model="valid" lazy-validation :disabled="disabledInputJRE"> -->
    <v-row>
        <v-col class="black--text">
         S.1 Berapakah jarak dan anggaran masa perjalanan dari tempat kediaman ke institusi pendidikan yang terdekat?<br>
        </v-col >
      </v-row>
            <v-container>
             <v-row>
                <v-col class="black--text">            
                  i. Sekolah rendah awam [SRA]
                         <v-row>
                           <v-col cols="4" sm="6" md="4" class="black--text">  
                             Jarak <strong> [SRAj]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                  <v-autocomplete
                                  :items="Jarak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="SRAj"
                                  :rules="[rules.SRAj]"
                                  ></v-autocomplete>
                                  </v-col>
                                    
                              
                              <v-col cols="4" sm="6" md="4" class="black--text">
                              Masa <strong>[SRAm]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                <v-autocomplete
                                  :items="Masa"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="SRAm"
                                  :rules="[rules.SRAm]"
                                  ></v-autocomplete>
                                 </v-col>
                          </v-row>        
                  </v-col > 
              </v-row>
              <v-row>
                  <v-col class="black--text">            
                  ii. Sekolah rendah swasta [SRS]
                         <v-row>
                           <v-col cols="4" sm="6" md="4" class="black--text">  
                             Jarak <strong> [SRSj]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                  <v-autocomplete
                                  :items="Jarak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="SRSj"
                                  :rules="[rules.SRSj]"
                                  ></v-autocomplete>
                                  </v-col>
                                    
                              
                              <v-col cols="4" sm="6" md="4" class="black--text">
                              Masa <strong>[SRSm]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                <v-autocomplete
                                  :items="Masa"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="SRSm"
                                  :rules="[rules.SRSm]"
                                  ></v-autocomplete>
                                 </v-col>
                          </v-row>        
                  </v-col > 
                 <!-- <v-col class="black--text">            
                  a. Sekolah rendah  [SR]
                         <v-row>
                           <v-col cols="4" sm="6" md="4" class="black--text">  
                             (i) Jarak <strong> [SRj]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                  <v-autocomplete
                                  :items="Jarak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="SR"
                                  :rules="[rules.SRj]"
                                  ></v-autocomplete>
                                  </v-col>
                                    
                              
                              <v-col cols="4" sm="6" md="4" class="black--text">
                              (ii) Masa <strong>[SRm]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                <v-autocomplete
                                  :items="Masa"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="SRm"
                                  :rules="[rules.SRm]"
                                  ></v-autocomplete>
                                 </v-col>
                          </v-row>        
                  </v-col >  -->
            </v-row>
  <!-- S152 -->
        <v-row>
           <v-col class="black--text">
          iii. Sekolah menengah awam [SMA]<br>
                    <v-row>
                       <v-col cols="4" sm="6" md="4" class="black--text">  
                             Jarak <strong>[SMAj]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                  <v-autocomplete
                                  :items="Jarak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="SMAj"
                                  :rules="[rules.SMAj]"
                                  ></v-autocomplete>
                              </v-col>
                              
                              <v-col cols="4" sm="6" md="4" class="black--text">
                              Masa <strong>[SMAm]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                <v-autocomplete
                                   :items="Masa"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="SMAm"
                                  :rules="[rules.SMAm]"
                                  ></v-autocomplete>
                                 </v-col>
                                 </v-row>        
                  </v-col > 
              </v-row>
              <v-row>
                  <v-col class="black--text">
                    iv. Sekolah menengah swasta [SMS]<br>
                    <v-row>
                       <v-col cols="4" sm="6" md="4" class="black--text">  
                             Jarak <strong>[SMSj]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                  <v-autocomplete
                                  :items="Jarak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="SMSj"
                                  :rules="[rules.SMSj]"
                                  ></v-autocomplete>
                              </v-col>
                              
                              <v-col cols="4" sm="6" md="4" class="black--text">
                              Masa <strong>[SMSm]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                <v-autocomplete
                                   :items="Masa"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="SMSm"
                                  :rules="[rules.SMSm]"
                                  ></v-autocomplete>
                                 </v-col>
                                 </v-row>        
                  </v-col >
            </v-row>
      <!-- S1-iii -->
          <v-row>
            <v-col class="black--text">
          v. Tadika awam [TAW]<br>
                             <v-row>
                              <v-col cols="4" sm="6" md="4" class="black--text">
                             Jarak <strong> [TAWj] </strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                  <v-autocomplete
                                  :items="Jarak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="TAW"
                                  :rules="[rules.TAWj]"
                                  ></v-autocomplete>
                              </v-col>
                              
                               <v-col cols="4" sm="6" md="4" class="black--text">
                              Masa <strong>[TAWm]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                <v-autocomplete
                                   :items="Masa"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="TAWm"
                                  :rules="[rules.TAWm]"
                                  ></v-autocomplete>
                                 </v-col>
                              </v-row>        
                  </v-col > 
            </v-row>
        <v-row>
           <v-col class="black--text">
             vi. Tadika swasta [TAS]<br>
                           <v-row>
                            <v-col cols="4" sm="6" md="4" class="black--text">
                             Jarak <strong>[TASj]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                  <v-autocomplete
                                  :items="Jarak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="TAS"
                                  :rules="[rules.TASj]"
                                  ></v-autocomplete>
                              </v-col>
                              
                              <v-col cols="4" sm="6" md="4" class="black--text">
                               Masa <strong> [TASm]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                <v-autocomplete
                                  :items="Masa"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  :rules="[rules.TASm]"
                                  v-model="TASm"
                                  ></v-autocomplete>
                                 </v-col>
                            </v-row>        
                    </v-col > 
             </v-row>   
    </v-container>
<!-- S150 -->
        <!-- <v-row>
           <v-col class="black--text">
            S150. Adakah perkhidmatan perpustakaan bergerak terdapat di kawasan anda? <strong>[PPB]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                            </v-col >
                          </v-row>
                        <v-container> 
                           <v-row>
                             <v-col cols="4" sm="6" md="4" class="black--text"> 
                                <v-autocomplete
                                  :items="yaTidak"
                                    :item-text="item => item.id +' - '+ item.desc"
                                    label=""
                                    return-object
                                    required
                                    solo
                                    outlined
                                    dense
                                    style="width:350px;"
                                    v-model="PPB"
                                  ></v-autocomplete>
                              </v-col>
                            </v-row>
                        </v-container> -->
    <!-- S3 -->
    <!-- <v-col v-show="showS151" class="black--text">
      <v-row>
         S151. Berapakah kekerapan perkhidmatan perpustakaan bergerak sampai ke kawasan anda?<strong> [KPB]</strong><br>
          </v-row>
              <v-row>
                             <v-col cols="4" sm="6" md="4"> 
                                <v-autocomplete
                                   :items="yaKPB"
                                    :item-text="item => item.id +' - '+ item.desc"
                                    return-object
                                    required                                   
                                    solo
                                    outlined
                                    dense
                                    style="width:350px;"
                                    v-model="KPB"
                                  ></v-autocomplete>
                              </v-col> 
                           </v-row>                         
                       
                    </v-col >                 -->
                    </v-form>
                   </v-card-text>

<v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        :disabled="checkMandatori()"
        v-show="dataJRE1.length <= 0" 
    >
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="kemaskiniJRE()"
    >
      Kemaskini
    </v-btn>
  </v-card-actions>
</v-card>

  
 
<!-- DIalog -->
<!-- <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{message}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
</v-dialog> -->

<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      width="500"
      height="200"
    >
    <v-card
    color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>
   
<v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                color="warning"
                @click='successDialog = false;'
            >
              Batal
            </v-btn>
            <v-btn
                color="pink"
                v-show="butangKemaskini"
                @click='successDialog = false;'
            >
              Kemaskini
            </v-btn>
            <v-btn
              color="primary"
              @click='goTo("2")'
            >
              Pengisian Seterusnya
            </v-btn>
      </v-card-actions>
       </v-card>
</v-dialog>
   
<!-- Pengesahan Padam Dialog -->
 <v-row justify="center">
    <v-dialog
      v-model="dialogPengesahan"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
         {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
         <!-- <strong>{{$t(" HID: "+this.HID)}}</strong> -->
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="dialogPengesahan = false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padam()"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

</div>
</template>
<script>
import axios from '../../plugins/axios'
//////////////////////////import services///////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 
import hidServices from "@/services/lookupField";
const lookup = new hidServices();
import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
    
    async beforeMount(){
        
        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;

        ///////////////////////////////dapatkan semua lookup table yang diperlukan//////////////////
        // this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        // this.NOAIR = this.currNOAIRData.NOAIR;
       
        this.Jarak = lookupFieldServices.getJarak();
        this.yaTidak = lookupFieldServices.getYaTidak();
        this.yaKPB = lookupFieldServices.getKPB();
        this.Masa = lookupFieldServices.getMasa();
        

        this.getData();//dapatkan data based on HID
    },
    // computed: {
    //    tambahlookuphargasebenar() {
    //   return lookup.getJarak();
    // },
    
        
    data: () => ({
        show151: true,
        updateButton: true,
        saveButton: false,
        disablesavebutton: true,
        disabledInput: true,
        disabledInputJRE: false,
        butangSimpan: true,
        butangSeterusnya: false,
        butangKemaskini: false,
        butangPadam: true,
        dialogPengesahan:false,
        dialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage:'',
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        search: '',
        yaTidak:[],
        /////////////////////data declaration//////////////////////////
        SRAj:[],
        SRAm:[],
        SRSj:[],
        SRSm:[],
        SMAj:[],
        SMAm:[],
        SMSj: [],
        SMSm: [],
        TAW:[],
        TAWm:[],
        TAS:[],
        TASm:[],
        // PPB:[],
        // KPB:[],
        dataJRE1: [],
        rules: {
          required: (v) => !!v || "field is required",
          SRAj: (v) => !!v || "Anggaran jarak perjalanan Sekolah Rendah adalah diperlukan",
          SRAm: (v) => !!v || "Anggaran masa perjalanan Sekolah Rendah adalah diperlukan",
          SRSj: (v) => !!v || "Anggaran masa perjalanan Sekolah Rendah adalah diperlukan",
          SRSm: (v) => !!v || "Anggaran masa perjalanan Sekolah Rendah adalah diperlukan",
          SMAj: (v) => !!v || "Anggaran jarak perjalanan Sekolah Menengah adalah diperlukan",
          SMAm: (v) => !!v || "Anggaran masa perjalanan Sekolah Menengah adalah diperlukan",
          SMSj: (v) => !!v || "Anggaran jarak perjalanan Sekolah Menengah adalah diperlukan",
          SMSm: (v) => !!v || "Anggaran jarak perjalanan Sekolah Menengah adalah diperlukan",
          TAWj: (v) => !!v || "Anggaran jarak perjalanan Sekolah Tadika Awam adalah diperlukan",
          TAWm: (v) => !!v || "Anggaran masa perjalanan Sekolah Tadika Awam adalah diperlukan",
          TASj: (v) => !!v || "Anggaran jarak perjalanan Sekolah Tadika Swasta adalah diperlukan",
          TASm: (v) => !!v || "Anggaran masa perjalanan Sekolah Tadika Swasta adalah diperlukan",
         
        },
        headers: [
          {
            // text: 'NOAIR',
            align: 'start',
            sortable: false,
            // value: 'NOAIR',
          },
         { text:'HID',  value:'HID'},
         { text:'SRAj',  value:'SRAj'},
         { text:'SRAm', value:'SRAm'},
         { text:'SRSj', value:'SRSj'},
         { text:'SRSm', value:'SRSm'},
         { text:'SMAj',  value:'SMAj'},
         { text:'SMAm', value:'SMAm'},
         { text:'SMSj', value:'SMSj'},
         { text:'SMSm', value:'SMSm'},
         { text:'TAW', value:'TAW'},
         { text:'TAWm', value:'TAWm'},
         { text:'TAS', value:'TAS'},
         { text:'TASm',value:'TASm'},
        //  { text:'PPB', value:'PPB'},
        //  { text:'KPB', value:'KPB'}, 
         
          
        ],
       ///////////link untuk ke page/////////////////////
      breadcrumbs: [
       {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
        {
          text: 'JRE',
          disabled: true,
          href: "JRE1",
        },
       

      ],
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      checkbox: false,
    }),
    methods: {
      validate () {
        this.$refs.form.validate()
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },


      async simpan (){

        if (this.$refs.form.validate()){
            this.dialog =  true;
            setTimeout(() => (this.dialog = false), 2000)
         
            try {

                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JRE/JRE1`, {
                HID: this.HID,
                SRAj:  this.SRAj.id,
                SRAm: this.SRAm.id,
                SRSj: this.SRSj.id,
                SRSm: this.SRSm.id,
                SMAj : this.SMAj.id,
                SMAm: this.SMAm.id,
                SMSj : this.SMSj.id,
                SMSm: this.SMSm.id,
                TAW: this.TAW.id, 
                TAWm: this.TAWm.id,
                TAS: this.TAS.id,
                TASm: this.TASm.id, 
                // PPB: this.PPB.id,
                // KPB: this.KPB.id,  
              })
                this.res = res.data
                this.successMessage = 'Data Disimpan!';
                this.getData();
                this.successDialog = true;
                //this.disabledInputJRE = true,
                // setTimeout(() => (this.successDialog = false), 2000);
                this.reset();
                window.scrollTo(0, 0);
                //setTimeout(() => (this.goTo()), 1000);
                
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
        }else{
          window.scrollTo(0, 0);
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'Please fill in the field!';
        }
      },
    

      async kemaskiniJRE(){
        this.dialog =  true;
        setTimeout(() => (this.dialog = false), 2000)
       
            try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JRE/kemaskiniJRE`, {
                
                HID: this.HID,
                SRAj:  this.SRAj.id,
                SRAm: this.SRAm.id,
                SRSj: this.SRSj.id,
                SRSm: this.SRSm.id,
                SMAj : this.SMAj.id,
                SMAm: this.SMAm.id,
                SMSj : this.SMSj.id,
                SMSm: this.SMSm.id,
                TAW: this.TAW.id, 
                TAWm: this.TAWm.id,
                TAS: this.TAS.id,
                TASm: this.TASm.id, 
                // PPB: this.PPB.id,
                // KPB: this.KPB.id,  
              })
              this.res = res.data;
          this.reset();
          this.getData();
          this.butangKemaskini = false;
          this.successMessage = 'Data Dikemaskini!';
          this.successDialog = true;
          window.scrollTo(0, 0);
          //setTimeout(() => (this.goTo()), 1000);
          } catch (error) {
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = "Kemaskini : " + error;
            }
      },

      async padam(){

        try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JRE/delete`, {
                HID:  this.HID,
                table: "JRE"
              }) 
              console.log(this.HID)
                this.res = res.data;
                //this.reset();
                this.dialogPengesahan = false;
                this.successDialog = true;
                // setTimeout(() => (this.successDialog = false), 1000);
                this.successMessage = 'Data Dipadam!'
                this.getData(); 
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 3000);
              this.errMessage = 'Padam je laaaa : '+error;
            }  
      },

      async getData(){
        //dapatkan data dari table JRE1 based on HID
        //console.log("masuk")
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/JRE/getDataJRE1?HID=`+this.HID, {
            })
            var dataz = res.data.data
            this.dataJRE1 = dataz;
            console.log(this.dataJRE1)
          } catch (error) {
            
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }
      },


      handleClick(row) {
          this.successDialog = true;
          this.kemaskiniDialog = true;
          this.successMessage = "Sila mulakan pengemaskinian!";
          // setTimeout(() => (this.kemaskiniDialog = false), 1000);

          this.showS151 = false;

          this.butangSimpan = false;
          this.butangKemaskini = true;
          //this.disabledInputJRE = false;

          this.HID = row.HID;
          
          if(row.SRAj == 1){
            this.SRAj = this.Jarak[0];
          }
          if(row.SRAj == 2){
            this.SRAj = this.Jarak[1];
          }
          if(row.SRAj == 3){
            this.SRAj = this.Jarak[2];
          }
           if(row.SRAm == 1){
            this.SRAm = this.Masa[0];
          }
          if(row.SRAm == 2){
            this.SRAm = this.Masa[1];
          }
          if(row.SRAm == 3){
            this.SRAm = this.Masa[2];
          }
          //-------------------------------
          if(row.SRSj == 1){
            this.SRSj = this.Jarak[0];
          }
          if(row.SRSj == 2){
            this.SRSj = this.Jarak[1];
          }
          if(row.SRSj == 3){
            this.SRSj = this.Jarak[2];
          }
           if(row.SRSm == 1){
            this.SRSm = this.Masa[0];
          }
          if(row.SRSm == 2){
            this.SRSm = this.Masa[1];
          }
          if(row.SRSm == 3){
            this.SRSm = this.Masa[2];
          }
          //-------------------------------
           if(row.SMAj == 1){
            this.SMAj = this.Jarak[0];
          }
          if(row.SMAj == 2){
            this.SMAj = this.Jarak[1];
          }
          if(row.SMAj == 3){
            this.SMAj = this.Jarak[2];
          }
           if(row.SMAm == 1){
            this.SMAm = this.Masa[0];
          }
          if(row.SMAm == 2){
            this.SMAm = this.Masa[1];
          }
          if(row.SMAm == 3){
            this.SMAm = this.Masa[2];
          }
          //-------------------------------
           if(row.SMSj == 1){
            this.SMSj = this.Jarak[0];
          }
          if(row.SMSj == 2){
            this.SMSj = this.Jarak[1];
          }
          if(row.SMSj == 3){
            this.SMSj = this.Jarak[2];
          }
           if(row.SMSm == 1){
            this.SMSm = this.Masa[0];
          }
          if(row.SMSm == 2){
            this.SMSm = this.Masa[1];
          }
          if(row.SMSm == 3){
            this.SMSm = this.Masa[2];
          }
          //----------------------------------------
            if(row.TAW == 1){
            this.TAW = this.Jarak[0];
          }
          if(row.TAW == 2){
            this.TAW = this.Jarak[1];
          }
          if(row.TAW == 3){
            this.TAW = this.Jarak[2];
          }
           if(row.TAWm == 1){
            this.TAWm = this.Masa[0];
          }
          if(row.TAWm == 2){
            this.TAWm = this.Masa[1];
          }
          if(row.TAWm == 3){
            this.TAWm = this.Masa[2];
          }
       //----------------------------------------
            if(row.TAS == 1){
            this.TAS = this.Jarak[0];
          }
          if(row.TAS == 2){
            this.TAS = this.Jarak[1];
          }
          if(row.TAS == 3){
            this.TAS = this.Jarak[2];
          }
           if(row.TASm == 1){
            this.TASm = this.Masa[0];
          }
          if(row.TASm == 2){
            this.TASm = this.Masa[1];
          }
          if(row.TASm == 3){
            this.TASm = this.Masa[2];
          }
      
        //----------------------------------------
          //   if(row.PPB == 1){
          //   this.PPB = this.yaTidak[0];
          // }
          // if(row.PPB == 2){
          //   this.PPB = this.yaTidak[1];
          // }
        //----------------------------------------
          //  if(row.KPB == 1){
          //   this.KPB = this.yaKPB[0];
          // }
          // if(row.KPB == 2){
          //   this.KPB = this.yaKPB[1];
          // }
          // if(row.KPB == 3){
          //   this.KPB = this.yaKPB[2];
          // }
          // if(row.KPB == 4){
          //   this.KPB = this.yaKPB[3];
          // }
         //----------------------------------------
      },
      
       goTo(option){
 
        if(option == "1"){
        this.$router.push({name: "ringkasanMaklumatIR"});
      } 
        if(option == "2"){
        this.$router.push({ name: "JRE2" });
          
        }
        //this.$router.push({name: "hk2", params: { data: this.data }});
      },

      checkMandatori(){
     
        if(this.SRAj =="" || this.SRAm =="" || this.SRSj =="" || this.SRSm =="" || this.SMAj =="" || this.SMAm =="" || this.SMSj =="" || this.SMSj =="" || this.TAW =="" || this.TAWm =="" || this.TAS =="" || this.TASm =="" ){
          return true;
          
        }else{
          return false;
        }
       

      }
    },
    watch:{

      // PPB(val){
      // if(val.id == 1){
      //     this.showS151 = true;
      //   }else{
      //     this.showS151 = false;
      //     this.KPB = { id: 0 };
      //   }        
      // },
     
      // KPB(val){
      //   if(val.id != 0){    
      //         if(this.TASm != "" && this.TAS != "" && this.TAWm != "" && this.TAW != "" && this.SMSj != "" && this.SMSm != "" && this.SMAm != "" && this.SMAj != "" && this.SRAm != ""  && this.SRAj != "" && this.SRSj != "" && this.SRSm != ""){  
      //           this.butangSimpan = false;
                                      
      //           }else{
      //           this.butangSimpan = true;
      //     }      
      //   }
      // },

     
    }
    
   
}
</script>

<style>
#app {
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}

</style>
